export const minBitrateFromVideoTracks = (videoTracks: any[]) => {
  return videoTracks.reduce((current, next) => {
    return current?.value?.bandwidth! < next?.value?.bandwidth! ? current?.value?.bandwidth! : next?.value?.bandwidth!;
  });
};
